import { useSWRConfig } from 'swr';

/* globalMutate('api/v1/board', 'isBookmark=1'); */

const useGlobalMutation = () => {
  const { mutate, cache } = useSWRConfig();

  return (api: string, matcher: string) => {
    if (!(cache instanceof Map)) {
      console.warn('사용 중인 cache가 SWR의 기본 Map 캐시가 아님');
      return false;
    }

    const keys = Array.from(cache.keys()).filter((key) => {
      return key.includes(api) && key.includes(matcher);
    });
    const mutations = keys.map((key) => {
      mutate(key);
    });

    return Promise.all(mutations);
  };
};

export default useGlobalMutation;
